import { render, staticRenderFns } from "./DevicePage.vue?vue&type=template&id=1c256b0a&scoped=true"
import script from "./DevicePage.vue?vue&type=script&lang=js"
export * from "./DevicePage.vue?vue&type=script&lang=js"
import style0 from "./DevicePage.vue?vue&type=style&index=0&id=1c256b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c256b0a",
  null
  
)

export default component.exports